import { FC } from 'react';
import classNames from 'clsx';
import { useHistory } from '../../hooks';
import { historyPushState } from '../../utilities/helpers';

type AnalyticsWidgetsProps = {
  icon: JSX.Element;
  className?: string;
  pattern?: JSX.Element;
  title: string;
  url: string;
  isNewFeature?: boolean;
};
export const AnalyticsWidgets: FC<AnalyticsWidgetsProps> = ({
  icon,
  pattern,
  title,
  className,
  url,
  isNewFeature = false,
}) => {
  const history = useHistory();
  const goTo = () => {
    historyPushState(url, history);
  };

  return (
    <div
      className={classNames(
        'flex items-center overflow-hidden justify-center transition-all cursor-pointer rounded-main bg-white w-[36rem] h-[22.7rem] relative group border-2 border-[#f0f0f0] hover:border-persianBlue hover:border-2',
        className,
      )}
      onClick={goTo}
    >
      {isNewFeature && (
        <div className="absolute text-2xl top-0 right-0 p-1 px-3 bg-red-600 text-white font-sans font-bold rounded-bl-xl shadow-[0_0_40px_15px_rgba(250,204,21,0.45)]">
          New!
        </div>
      )}
      <div className="absolute w-full h-full flex flex-col items-center justify-between py-[5.2rem]">
        <div className="">{icon}</div>
        <div className="text-2430 font-bold font-lato group-hover:text-persianBlue">{title}</div>
      </div>
      <div className="">{pattern}</div>
    </div>
  );
};
